import api from './client';

// BYOK 自付控制台（预设目录）——独立通道：用户自填 key 直连供应商，平台不计费
export interface ByokPresetModel {
  id: string;
  name: string;
  provider_model_id: string;
  description?: string;
  context_length?: number;
}

export interface ByokPreset {
  slug: string;
  name: string;
  region: 'cn' | 'intl';
  base_url?: string | null;
  key_url?: string | null;
  legacy: boolean;
  custom?: boolean;
  models_probe: boolean;
  configured: boolean;
  /** 亮灯：key 已存且已选 ≥1 */
  lit: boolean;
  key_tail: string;
  models: ByokPresetModel[];
}

export interface ByokPresetList {
  presets: ByokPreset[];
  configured_count: number;
  catalog_version: string;
}

export interface FetchedModel {
  id: string;
  added: boolean;
  row_id?: string | null;
}

export const byokApi = {  listPresets: () =>
    api.get<ByokPresetList>('/api/v1/llm/byok-presets').then((r) => r.data),

  saveKey: (slug: string, apiKey: string, baseUrl?: string) =>
    api.put<{ ok: boolean; configured: boolean; key_tail: string }>(
      `/api/v1/llm/byok-presets/${slug}/key`, { api_key: apiKey, base_url: baseUrl }
    ).then((r) => r.data),

  clearKey: (slug: string) =>
    api.delete<{ ok: boolean; configured: boolean }>(
      `/api/v1/llm/byok-presets/${slug}/key`
    ).then((r) => r.data),

  fetchModels: (slug: string) =>
    api.get<{ models: FetchedModel[] }>(
      `/api/v1/llm/byok-presets/${slug}/models`
    ).then((r) => r.data),

  addModels: (slug: string, modelIds: string[]) =>
    api.post<{ ok: boolean; added: string[]; skipped: string[]; models: ByokPresetModel[] }>(
      `/api/v1/llm/byok-presets/${slug}/models`, { model_ids: modelIds }
    ).then((r) => r.data),

  removeModel: (slug: string, rowId: string) =>
    api.delete<{ ok: boolean; models: ByokPresetModel[] }>(
      `/api/v1/llm/byok-presets/${slug}/models/${rowId}`
    ).then((r) => r.data),
};

/** 用户在 BYOK 控制台已选的目录行 id 集合（选择器/LLM 控制台可见性口径：
 * 填了 key 且选了的才显示——已配置厂商的已选行） */
export const pickedModelIds = (data?: ByokPresetList): Set<string> =>
  new Set(
    (data?.presets || [])
      .filter((p) => p.configured)
      .flatMap((p) => p.models.map((m) => m.id))
  );
